// extracted by mini-css-extract-plugin
export default {"font-container":"styles_font-container__EY6sU","font-fallback":"styles_font-fallback__lQnBd","error-message":"styles_error-message__c+5Eq"};